module.exports = __webpack_public_path__ + "img/b395267.jpg";